import React from 'react';
import { BUSINESS } from '../../data/siteData';

export default function FloatCallButton() {
  return (
    <a
      href={`tel:${BUSINESS.phoneRaw}`}
      title={`Call ${BUSINESS.phone}`}
      style={{
        position: 'fixed', bottom: '2rem', right: '2rem', zIndex: 90,
        background: 'var(--orange)', color: 'white', textDecoration: 'none',
        width: 60, height: 60, borderRadius: '50%',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '1.5rem', transition: 'transform 0.2s',
      }}
      className="animate-pulse-ring"
      onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.12)'}
      onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
    >
      📞
    </a>
  );
}
